import plugin_vue3_A0OWXRrUgq from "/home/vsts/work/1/s/UI/mycim-app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/vsts/work/1/s/UI/mycim-app/.nuxt/components.plugin.mjs";
import vueuse_head_plugin_D7WGfuP1A0 from "/home/vsts/work/1/s/UI/mycim-app/node_modules/nuxt/dist/head/runtime/lib/vueuse-head.plugin.mjs";
import router_Pg0DINazwm from "/home/vsts/work/1/s/UI/mycim-app/node_modules/nuxt/dist/pages/runtime/plugins/router.mjs";
import prefetch_client_3cwHvxIDEX from "/home/vsts/work/1/s/UI/mycim-app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.mjs";
import composition_sLxaNGmlSL from "/home/vsts/work/1/s/UI/mycim-app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/home/vsts/work/1/s/UI/mycim-app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import payload_client_5Om5dvb8Jc from "/home/vsts/work/1/s/UI/mycim-app/node_modules/nuxt/dist/app/plugins/payload.client.mjs";
import analytics_SVnwK7EMrr from "/home/vsts/work/1/s/UI/mycim-app/plugins/analytics.ts";
import maska_UHaKf2z1iQ from "/home/vsts/work/1/s/UI/mycim-app/plugins/maska.ts";
import vuetify_7h9QAQEssH from "/home/vsts/work/1/s/UI/mycim-app/plugins/vuetify.ts";
export default [
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  vueuse_head_plugin_D7WGfuP1A0,
  router_Pg0DINazwm,
  prefetch_client_3cwHvxIDEX,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  payload_client_5Om5dvb8Jc,
  analytics_SVnwK7EMrr,
  maska_UHaKf2z1iQ,
  vuetify_7h9QAQEssH
]